import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "absolute top-0 left-0 right-0 flex justify-between items-center p-0 bg-[#311C1333] backdrop-blur-[20px] border-b-[1px] border-white border-opacity-30 z-50 h-12 xl:h-[65px]" }
const _hoisted_2 = { class: "inline-flex items-center" }
const _hoisted_3 = {
  key: 1,
  class: "flex justify-between p-0 ml-[17px] md:ml-[25px] xl:ml-8"
}
const _hoisted_4 = { class: "inline-flex items-center space-x-3 [&_.active-breadcrumb]:opacity-70" }
const _hoisted_5 = {
  key: 0,
  class: "hidden xl:inline-flex items-center py-1 sf-pro-sm text-white active-breadcrumb cursor-default"
}
const _hoisted_6 = {
  key: 0,
  width: "7",
  height: "13",
  viewBox: "0 0 7 13",
  fill: "none",
  class: "mr-2 xl:hidden",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = {
  key: 0,
  class: "mx-2 sf-pro-sm text-white opacity-70 hidden xl:block"
}
const _hoisted_8 = { class: "xl:flex gap-4 mr-2 hidden" }
const _hoisted_9 = {
  key: 0,
  class: "group rounded-full"
}

import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import EmailIcon from "@/components/icons/EmailIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import BlogButton from "@/components/buttons/BlogButton.vue";
import LoginButton from "@/components/buttons/LoginButton.vue";
import { Breadcrumbs } from "@/types/breadcrumbs";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSocialsStore } from "@/stores/socialsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AbsolutePageHeader',
  props: {
    showBlogBtn: { type: Boolean },
    breadcrumbs: {}
  },
  setup(__props: any) {

const { t } = useI18n();
const socialStore = useSocialsStore();

const props = __props;

const emailLink = computed(() => socialStore.socialLinks.email);
const instagramLink = computed(() => socialStore.socialLinks.instagram);

onMounted(async () => {
  await socialStore.loadSocials();
});

function openSocialLink(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

function openLoginPage() {
  router.push({ name: ROUTE_NAMES.USER });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.showBlogBtn)
        ? (_openBlock(), _createBlock(BlogButton, { key: 0 }))
        : _createCommentVNode("", true),
      (props.breadcrumbs && props.breadcrumbs.length)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            _createElementVNode("ol", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.breadcrumbs, (breadcrumb, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: breadcrumb.path
                }, [
                  _createElementVNode("li", null, [
                    (index === props.breadcrumbs.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)(breadcrumb.label)), 1))
                      : (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: breadcrumb.path,
                          class: "inline-flex items-center py-1 focus:outline-none sf-pro-sm text-white"
                        }, {
                          default: _withCtx(() => [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("path", {
                                    d: "M6.5 1L1 6.5L6.5 12",
                                    stroke: "white",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_unref(t)(breadcrumb.label)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                  ]),
                  (index < props.breadcrumbs.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " / "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (emailLink.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_9, [
            _createVNode(EmailIcon, { type: "white" })
          ]))
        : _createCommentVNode("", true),
      (instagramLink.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "group rounded-full",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openSocialLink(instagramLink.value)))
          }, [
            _createVNode(InstagramIcon, { type: "white" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoginButton, { onClick: openLoginPage })
    ])
  ]))
}
}

})